import React from "react";

function ReportData() {
  return (
    <div>
      <h1 className="comingSoon" style={{ fontSize: 40 }}>
        Coming Soon...
      </h1>
    </div>
  );
}

export default ReportData;
